import React, { useEffect, useRef, useState } from "react";

export default function Clients() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        },
        { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const clients = [
    { name: "Wilmar", logo: "/assets/images/wilmar.png" },
    { name: "Indofood", logo: "/assets/images/indofood.png" },
    { name: "Bungasari", logo: "/assets/images/bungasari.jpeg" },
    { name: "PT. Catur Global Logistik", logo: "/assets/images/catur.png" },
    { name: "PT. Pundi Kencana", logo: "/assets/images/pundi.jpg" },
  ];

  return (
      <section
          ref={sectionRef}
          className="py-32 bg-gradient-to-b from-white via-gray-50 to-white relative overflow-hidden"
      >
        {/* Decorative Elements */}
        <div className="absolute top-1/4 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-secondary/5 rounded-full blur-3xl"></div>

        <div className="container mx-auto px-6 lg:px-12 relative z-10">
          <div className="text-center mb-20">
            <h2
                className={`text-5xl lg:text-6xl font-bold text-gradient mb-6 transition-all duration-1000 ${
                    isVisible
                        ? "opacity-100 translate-y-0"
                        : "opacity-0 translate-y-20"
                }`}
            >
              Klien Kami
            </h2>
            <p
                className={`text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed transition-all duration-1000 ${
                    isVisible
                        ? "opacity-100 translate-y-0"
                        : "opacity-0 translate-y-20"
                }`}
                style={{ transitionDelay: "0.1s" }}
            >
              Dipercaya oleh perusahaan-perusahaan terkemuka di Indonesia
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {clients.map((client, index) => (
                <div
                    key={index}
                    className={`glass-dark rounded-3xl p-8 shadow-xl card-premium flex flex-col items-center justify-center min-h-[180px] border border-primary/10 transition-all duration-1000 ${
                        isVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"
                    }`}
                    style={{ transitionDelay: `${0.2 + index * 0.1}s` }}
                >
                  <div className="w-24 h-24 mb-4 rounded-2xl overflow-hidden shadow-lg bg-white p-2 flex items-center justify-center">
                    <img
                        src={client.logo}
                        alt={client.name}
                        className="w-full h-full object-contain"
                    />
                  </div>
                  <p className="text-primary font-bold text-center text-sm">
                    {client.name}
                  </p>
                </div>
            ))}
          </div>
        </div>
      </section>
  );
}
